import {BaseMyopMessage} from "../BaseMessage";

export class SetMutationObserverMessage extends BaseMyopMessage {
    messageType = 'SetMutationObserverMessage';
}

export class MutationObserverMessage extends BaseMyopMessage {
    messageType = 'MutationObserverMessage';
}